if (!Object.keys) {
	Object.keys = function(o) {
		'use strict';
		if (o !== Object(o)) {
			throw new TypeError('Object.keys called on non-object');
		}
		var ret = [], p;
		for (p in o) {
			if (Object.prototype.hasOwnProperty.call(o, p)) {
				ret.push(p);
			}
		}
		return ret;
	};
}
;
define("all/Object", function(){});

